import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import socket from "../../assets/socketConnection";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
import LoadingPage from "../../components/loadingPage/loadingPage.component";
// import { selectInstantReqStatus } from "../../redux/instantReq/instantReq.selectors";
import { selectNewRequestSuggestionPrice } from "../../redux/newRequest/newRequest.selectors";
import { roundToThousand } from "../../utils/utils";
import { InstantReqPageFailedStyled } from "./instantReqPageFailed.styles";

const InstantReqPageFailed = () => {
  const sugPrice = useSelector(selectNewRequestSuggestionPrice);
  // const reqStatus = useSelector(selectInstantReqStatus);
  const params = useParams();
  const browserHistory = useHistory();
  const [showLoading, setShowLoading] = useState(false);
  const [price, setPrice] = useState();

  useEffect(() => {
    setPrice(sugPrice.suggested_price);
  }, [sugPrice]);

  const initialPrice = sugPrice.suggested_price;

  const priceStep = Number(((Number(initialPrice) * 5) / 100).toFixed());

  const [minesIsActive, setMinesIsActive] = useState(false);

  socket.on("response_member_converts_instant_to_normal", (data) => {
    console.log(data);
    setShowLoading(false);
    if (data.status === 1) {
      browserHistory.push("/reqs");
    }
  });
  socket.on("response_member_cancels_instant_request", (data) => {
    console.log(data);
    // alert("sdf");
    setShowLoading(false);
    if (data.status === 1) {
      browserHistory.push("/reqs");
    }
  });
  socket.on("response_member_repeats_instant_request", (data) => {
    console.log(data);
    setShowLoading(false);
    if (data.status === 1) {
      browserHistory.push("/reqs");
    }
  });

  const onUpperPrice = () => {
    const newPrice = price + roundToThousand(priceStep);
    const formatedPrice = roundToThousand(newPrice);
    setMinesIsActive(true);

    setPrice(formatedPrice);
  };
  const onLowerPrice = () => {
    const newPrice = price - roundToThousand(priceStep);
    const formatedPrice = roundToThousand(newPrice);
    if (formatedPrice <= initialPrice) {
      setPrice(initialPrice);
      setMinesIsActive(false);
      return;
    }

    setPrice(formatedPrice);
  };
  const onTavafoghClick = () => {
    // alert('tava')
    setShowLoading(true);
    socket.emit("member_converts_instant_to_normal", { load_id: params.id });
  };
  const onReqAgainClick = () => {
    if (price === initialPrice) {
      return;
    }
    socket.emit("member_repeats_instant_request", {
      suggested_price: initialPrice,
      user_changed_suggested_price: { status: true, amount: price },
    });

    socket.emit("instant_request_status", { load_id: params.id });
  };
  const onCancelClick = () => {
    setShowLoading(true);
    socket.emit("member_cancels_instant_request", { load_id: params.id });
  };

  return (
    <InstantReqPageFailedStyled>
      <LoadingPage isShow={showLoading} />

      <div className="inner">
        <div className="inner__white">
          <div>
            <svg
              className="mx-auto mt-3 d-block"
              xmlns="http://www.w3.org/2000/svg"
              id="icn_rating_2"
              width="30"
              height="30"
              viewBox="0 0 30 30"
            >
              <rect
                id="Rectangle_1929"
                width="30"
                height="30"
                fill="#ffbf1d"
                rx="10"
              />
              <circle
                id="Ellipse_467"
                cx="2.118"
                cy="2.118"
                r="2.118"
                fill="#fff"
                transform="translate(6.176 6.882)"
              />
              <circle
                id="Ellipse_468"
                cx="2.118"
                cy="2.118"
                r="2.118"
                fill="#fff"
                transform="translate(19.588 6.882)"
              />
              <g id="Group_694" transform="translate(-114)">
                <path
                  id="Path_2283"
                  d="M136.412 23.118A1.412 1.412 0 0 1 135 21.706c0-2.919-2.692-5.294-6-5.294s-6 2.375-6 5.294a1.412 1.412 0 1 1-2.824 0c0-4.476 3.959-8.118 8.824-8.118s8.824 3.642 8.824 8.118a1.412 1.412 0 0 1-1.412 1.412z"
                  fill="#fff"
                />
              </g>
            </svg>
          </div>
          <div className="font-weight-bold font-size--1 text-center my-2">
            متاسفانه خودرویی یافت نشد.
          </div>
          <div className="text-muted font-size--n1 text-center mb-2">
            برای پیدا کردن خودرو می‌توانید یکی از گزینه‌های زیر را انتخاب کنید.
          </div>
          <div className="mt-2 d-flex align-items-center justify-content-between">
            <button
              onClick={onReqAgainClick}
              className="btn btn-outline-secondary dark-btn font-size--n4"
              style={{ width: "45%" }}
              // disabled={price === initialPrice}
            >
              درخواست مجدد
            </button>
            <div
              className="d-flex align-items-center justify-content-between pr-2"
              style={{ width: "55%" }}
            >
              <button onClick={onUpperPrice}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                >
                  <g id="Group_1147" transform="translate(-42 -540)">
                    <g
                      id="Rectangle_906"
                      fill="none"
                      transform="translate(60 558) rotate(180)"
                      stroke="#9496A0"
                    >
                      <rect width="18" height="18" stroke="none" rx="7"></rect>
                      <rect
                        width="17"
                        height="17"
                        x=".5"
                        y=".5"
                        rx="6.5"
                      ></rect>
                    </g>
                    <path
                      id="Line_75"
                      d="M0 0L8 0"
                      transform="translate(47 549.5)"
                      stroke="#9496A0"
                    ></path>
                    <path
                      id="Line_174"
                      d="M0 0L8 0"
                      transform="translate(51 545.5) rotate(90)"
                      stroke="#9496A0"
                    ></path>
                  </g>
                </svg>
              </button>
              <span className="small">
                <span>{toSeperatedNum(toPersianNum(price))}</span>
                <span> تومان</span>
              </span>
              <button onClick={onLowerPrice} disabled={!minesIsActive}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                >
                  <g fill="none" stroke="#2a2e43" opacity="0.5">
                    <g transform="translate(-42 -540) translate(60 558) rotate(180)">
                      <rect width="18" height="18" stroke="none" rx="7" />
                      <rect width="17" height="17" x=".5" y=".5" rx="6.5" />
                    </g>
                    <path
                      strokeLinecap="round"
                      d="M0 0L8 0"
                      transform="translate(-42 -540) translate(47 549.5)"
                    />
                  </g>
                </svg>
              </button>
            </div>
          </div>
          <div>
            <button
              onClick={onTavafoghClick}
              className="btn btn-outline-secondary dark-btn mt-2 font-weight-bold"
            >
              تبدیل به توافقی
            </button>
          </div>
        </div>
        <div>
          <button
            onClick={onCancelClick}
            className="btn btn-danger cancel-btn w-100 my-3"
          >
            لغو درخواست
          </button>
        </div>
      </div>
    </InstantReqPageFailedStyled>
  );
};

export default InstantReqPageFailed;
